import { useQuery } from '@tanstack/react-query';
import { ledgerKeys } from '../../ledgers/constants/ledger.constant';
import { useActiveLedger } from '../../ledgers/hooks/use-active-ledger';
import { shellService } from '../services/shell.service';

const PENDING_REFETCH_MS = 60_000;

export function usePendingJoinRequests(): number {
  const { ledger } = useActiveLedger();
  const ledgerId = ledger?.id ?? '';
  const query = useQuery({
    queryKey: [...ledgerKeys.scoped(ledgerId), 'pending-count'],
    queryFn: () => shellService.pendingCount(ledgerId),
    enabled: ledgerId !== '',
    select: (r) => r.joinRequests,
    refetchInterval: PENDING_REFETCH_MS,
  });
  return query.data ?? 0;
}
